module.exports = __webpack_public_path__ + "img/流体力学1_5_1.6f35e133.jpg";